import { EventEmitter, Injectable, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { Venmaetransportistas } from '../../ven/veninterfaces/venmaetransportistas';
import { HttpClient } from '@angular/common/http';
import { UsuarioEsquema } from '../../usuarioEsquema';
import { Usuario } from '../../usuario';
import { Conmaetipodiario } from '../coninterfaces/conmaetipo-diario';
import { Observable } from 'rxjs';
import { ConfInicialesService } from 'src/app/servicios/conf-iniciales.service';

@Injectable({
  providedIn: 'root'
})
export class ConmaetipgastoService {

  public way: string;

  constructor(private http: HttpClient,
    public usuarioEsquema: UsuarioEsquema,
    public usuario: Usuario,
    private confIniciales: ConfInicialesService) {
    this.way = sessionStorage.getItem('way');
  }

  getTipogasto(){
    return this.http.post<any[]>(this.way + '/cont/tipgasto/20eed94eecb3060000', {
        elementos: {},
      }, this.confIniciales.httpOptions()).toPromise();
  }
  guardarTipoGasto(tipodiario) {
    return this.http.post<any>(this.way + '/cont/tipgasto/257e3b7d5594ee000000000', {
      elementos: {
        p_TIPGAS_codigo_1: tipodiario.TIPGAS_CODIGO,
        p_TIPGAS_nombre_2: tipodiario.TIPGAS_NOMBRE,
        p_COM_codigo_3: '01'
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  
  actualizarTipoGasto(tipodiario){
    return this.http.post<any>(this.way + '/cont/tipgasto/299df2ab2', {
      elementos: {
        p_TIPGAS_codigoa:tipodiario.TIPGAS_CODIGO,
        p_TIPGAS_codigo_1: tipodiario.TIPGAS_CODIGO,
        p_TIPGAS_nombre_2: tipodiario.TIPGAS_NOMBRE,
        p_COM_codigo_3: '01'
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
  eliminarTipoGasto(tipodiario){
    return this.http.post<any>(this.way + '/cont/tipgasto/1d595a575594ef000000000', {
      elementos: {
        p_TIPGAS_codigo_1:tipodiario.TIPGAS_CODIGO,
        p_COM_codigo_2: '01'
      }
    }, this.confIniciales.httpOptions()).toPromise();
  }
}
